import { css, unsafeCSS } from 'lit';
import {sbkCoreBreakpointLg, sbkCoreBreakpointMd} from "@/tokens/variables";

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);
const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const infoboxStyles = css`
    :host {
        display: block;
    }

    
    .infobox {
        padding: var(--sbkCoreSpacing3xl) var(--sbkCoreGridSmMargin);
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: var(--sbkInfoBoxSpacingSmallScreenGap);
        flex: 1;
        border-radius: var(--sbkInfoBoxBorderRadiusLargeScreen);

        @media all and (min-width: ${breakpointMd}) {
            padding: var(--sbkCoreSpacing3xl) var(--sbkCoreGridMdMargin);
        }

        @media all and (min-width: ${breakpointLg}) {
            padding: var(--sbkInfoBoxSpacingLargeScreenInsetTopBottom) var(--sbkInfoBoxSpacingLargeScreenInsetLeftRight);
            gap: var(--sbkInfoBoxSpacingLargeScreenGap);
        }
    }

    .infobox--variant-info {
        background-color: var(--sbkInfoBoxColorBgColorInfo);
    }

    .infobox--variant-success {
        background-color: var(--sbkInfoBoxColorBgColorSuccess);
    }

    .infobox--variant-error {
        background-color: var(--sbkInfoBoxColorBgColorError);
    }

    .infobox--variant-note {
        background-color: var(--sbkInfoBoxColorBgColorNote);
    }

    .control-buttons {
        display: flex;
        flex-direction: column;
        gap: var(--sbkInfoBoxSpacingSmallScreenGapButtons);
        @media all and (min-width: ${breakpointLg}) {
            flex-direction: row-reverse;
            gap: var(--sbkInfoBoxSpacingLargeScreenGapButtons);
        }
    }

    .links {
        display: flex;
        flex-direction: column;
        gap: var(--sbkInfoBoxSpacingSmallScreenGapLinks);
        @media all and (min-width: ${breakpointLg}) {
            gap: var(--sbkInfoBoxSpacingLargeScreenGapLinks);
        }
    }

    .headline-bodytext {
        display: flex;
        flex-direction: column;
        gap: var(--sbkInfoBoxSpacingSmallScreenGapHeadlineBodyLinks);
        @media all and (min-width: ${breakpointLg}) {
            gap: var(--sbkInfoBoxSpacingLargeScreenGapHeadlineBodyLinks);
        }
    }
    
    .headline-icon {
        display: flex;
        gap: var(--sbkInfoBoxSpacingSmallScreenGapIconHeadline);
        align-items: flex-start;
        @media all and (min-width: ${breakpointLg}) {
            gap: var(--sbkInfoBoxSpacingLargeScreenGapIconHeadline);
        }
    }
    
    ::slotted(*) {
        font: var(--sbkInfoBoxTypographySmallScreenBody);
    }

    slot[name="icon"]::slotted(img), slot[name="icon"]::slotted(sbk-icon), sbk-icon::part(icon) {
        width: var(--sbkInfoBoxSizingSmallScreenSizeIcon);
        height: var(--sbkInfoBoxSizingSmallScreenSizeIcon);
    }
    
    slot[name="headline"]::slotted(*) {
        margin: 0 !important;
        align-self: center;
        font: var(--sbkInfoBoxTypographySmallScreenHeadline) !important;
    }

    @media all and (min-width: ${breakpointLg}) {
        slot[name="icon"]::slotted(img), sbk-icon::part(icon) {
            width: var(--sbkInfoBoxSizingLargeScreenSizeIcon);
            height: var(--sbkInfoBoxSizingLargeScreenSizeIcon);
        }
        slot[name="headline"]::slotted(*) {
            font: var(--sbkInfoBoxTypographyLargeScreenHeadline) !important;
        }
        ::slotted(*) {
            font: var(--sbkInfoBoxTypographyLargeScreenBody);
        }
    }
    
    .hide {
        display: none;
    }
`;
